import TextCell from 'app/components/data-table/TextCell';
import TimestampCell from 'app/components/data-table/TimestampCell';
import EditablePipelineTags from './EditablePipelineTags';

export default function buildStatusTableContents({ lastDeployed, pipelineId }) {
  return [
    {
      0: { Component: TextCell, componentProps: { text: 'Last Deployed', variant: 'body2' } },
      1: { Component: TimestampCell, componentProps: { timestamp: lastDeployed, 'data-test-id': 'lastDeployedDate' } },
    },
    {
      0: { Component: TextCell, componentProps: { text: 'Tags', variant: 'body2' } },
      1: { Component: EditablePipelineTags, componentProps: { pipelineId } },
    },
  ];
}
